// extracted by mini-css-extract-plugin
export default {"checkmark":"_2hecm","iconAnimation":"oBvrb","typewriter":"_3fpzr","textAnimation":"_XWna","centerInPage":"_1MJ_s"};